import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '@intigral/domain/lib/DataDomain';
import { IProfileService } from '@intigral/domain/lib/application/services/ProfileService';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import _ from 'lodash';
import { getUserInfo } from '../../utils/user';
import { toast } from '@intigral/shared';
import { __ } from '../../translations';
import user from '../../helpers/user';

export const useToggleWatchlistItem = () => {
    const client = useQueryClient();

    return useMutation({
        mutationFn: async ({
            itemId,
            category,
            isAdded,
        }: {
            itemId: string;
            category: 'vod' | 'linear';
            isAdded: boolean;
        }) => {
            const profileService = container.resolve<IProfileService>(DI.SERVICES.IProfileService);
            const userObject = getUserInfo();

            if (isAdded) {
                return profileService.deleteWatchlist(
                    category,
                    userObject.apiKey,
                    user.getProfile()?.profileGuid,
                    [itemId],
                    userObject.authToken,
                    userObject.identityToken
                );
            }
            return profileService.addWatchlist(
                category,
                userObject.apiKey,
                user.getProfile()?.profileGuid,
                [itemId],
                userObject.authToken,
                userObject.identityToken
            );
        },
        onMutate: async ({ itemId, isAdded }) => {
            await client.cancelQueries({ queryKey: ['profiles', 'user-watchlist'] });

            const previous = client.getQueryData(['profiles', 'user-watchlist']);

            client.setQueryData(['profiles', 'user-watchlist'], (old: any[] = []) => {
                if (isAdded) {
                    return old.filter((item) => item.Id !== itemId);
                }

                return [...old, { Id: itemId }];
            });

            return { previous };
        },

        onError: (_err: any, _vars, context) => {
            toast(__(_err?.data?.code), 'error');
            if (context?.previous) {
                client.setQueryData(['profiles', 'user-watchlist'], context.previous);
            }
        },

        onSettled: () => {
            client.invalidateQueries({ queryKey: ['profiles', 'user-watchlist'] });
        },
    });
};
